import { StarFilled } from '@ant-design/icons';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { images } from '../../assets';
import SImage from '../SImage';

const AgencyItem = ({ data, active = false }) => {
    const navigate = useNavigate();
    return (
        
        <div
            //  onClick={()=> {
            //     navigate(
            //         `/agency-details/${data.id}`
            //       ); 
            className={`flex rounded-[10px] p-2.5 items-center bg-white shadow-md text-left	 hover:shadow-lg mb-4 sm:mr-4 w-full sm:w-auto ${active && `bg-[#EDF8FF] border-2 border-[#2297D4]`}`}>
                <div>
                <div className="w-[50px] h-[50px] rounded-xl">
                <SImage
                    src={data.avatar}
                    className="object-cover w-full h-full"
                    alt=""
                />
            </div>
                </div>

            <div className="flex flex-col ml-2.5">
                <span className="text-[12px] sm:text-sm font-bold text-[#222222] not-italic capitalize text-one-lines sm:text-two-lines">
                    {data?.name}
                </span>

                <div className="flex items-center text-[10px] sm:text-sm font-semibold ">
                    <StarFilled className="mr-2 text-yellow-300" /> {data?.star || 0}
                </div>
                <span className="text-[10px] sm:text-sm not-italic capitalize text-one-lines sm:text-two-lines">
                    Địa chỉ: {data?.address}
                </span>
            </div>
        </div>
    );
};

export default AgencyItem;